<template>
  <svg
    class="custom-icon"
    width="18"
    height="15"
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.4311 0.323991C18.0806 0.838199 18.1903 1.78159 17.6761 2.43111L8.17607 14.4311C7.91041 14.7667 7.51405 14.9728 7.08677 14.9975C6.65949 15.0223 6.24198 14.8634 5.93934 14.5607L0.43934 9.06072C-0.146447 8.47493 -0.146447 7.52519 0.43934 6.9394C1.02513 6.35361 1.97487 6.35361 2.56066 6.9394L6.86952 11.2483L15.3239 0.569006C15.8381 -0.0805191 16.7815 -0.190216 17.4311 0.323991Z"
    />
  </svg>
</template>
